<template>
<Card>
  <CardHeader :goal="course.goal" slot="header"></CardHeader>
  <CardMeta :curator="course.curator" :date="course.date" slot="meta"></CardMeta>
  <div slot="list" role="list">
    <div class="ui selection relaxed list"
         v-for="(checkpoint, checkpointId) in checkpoints">
      <CardCheckpoint :checkpointId="checkpointId" :checkpoint="checkpoint">
      </CardCheckpoint>
    </div>
  </div>
  <Labels slot="labels" :options="languages" :selected="selectedLanguage"></Labels>
  </div>
</Card>
</template>

<script>
import Card from './Card.vue';
import CardHeader from './CardHeader.vue';
import CardMeta from './CardMeta.vue';
import CardCheckpoint from './CardCheckpoint.vue';
import Labels from './Labels.vue';
import _ from 'lodash';
export default {
  name: 'app',
  components: { Card, Labels, CardHeader, CardMeta, CardCheckpoint },
  props: ['course', 'checkpoints', 'languages', 'selectedLanguage']
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue